import { NextPage, NextPageContext } from 'next'
import { useUserQuery } from 'graphql/generated'
import ErrorMessage from 'components/ErrorMessage'
import Profile from 'components/profiles/Profile'
import NavbarLayout from 'components/NavbarLayout'
import ScreenLayout from 'components/ScreenLayout'

interface IProps {
  profileId: string
}

const ProfilePage: NextPage<IProps> = ({ profileId }) => {
  const { data, error } = useUserQuery({
    variables: {
      id: profileId
    }
  })
  const user = data?.user

  return (
    <NavbarLayout>
      <ScreenLayout layout="generic_sidebar">
        {!!error && (
          <ErrorMessage
            message={`We couldn't load this Profile right now. Please try again later.`}
          />
        )}

        {!!user && <Profile user={user} />}
      </ScreenLayout>
    </NavbarLayout>
  )
}

ProfilePage.getInitialProps = async (ctx: NextPageContext) => {
  const profileId: string = ctx.query.profileId as string
  return { profileId }
}

export default ProfilePage
